"use strict";
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
Object.defineProperty(exports, "__esModule", { value: true });
var styles = [".form-content[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{margin-bottom:12px}.padding-btm[_ngcontent-%COMP%]{padding-bottom:10px}"];
exports.styles = styles;
